<div [formGroup]="passwordForm">
  <!-- Password -->
  <div class="input-form-box">
    <ion-label>{{ 'FORM.LABELS.PASSWORD' | translate }}*</ion-label>
    <div class="input-box">
      <input
        [ngStyle]="{'border': (submitted && passwordControl?.invalid) ? '1px rgba(152, 26, 48, 1) solid' : '1px white solid'}"
        autocomplete="off"
        formControlName="password"
        placeholder="{{ 'FORM.PLACEHOLDER.PASSWORD' | translate }}"
        [type]="textType"
      />
      <div 
        class="eye-icon"
        [ngClass]="{'show-password': textType === 'password', 'hide-password': textType === 'text'}"
        (click)="togglePasswordVisibility()">
      </div>
    </div>
    <div
      *ngIf="submitted && passwordControl?.hasError('required')"
      class="error-message"
    >
      {{ 'FORM.ERROR.REQUIRED' | translate }}
    </div>
    <div
      *ngIf="submitted && passwordControl?.hasError('minlength')"
      class="error-message"
    >
      {{ 'FORM.VALID.PASSWORD_VALID' | translate }}
    </div>
  </div>

  <!-- Confirm Password -->
  <div class="input-form-box">
    <ion-label>{{ 'FORM.LABELS.CONFIRM_PASSWORD' | translate }}*</ion-label>
    <div class="input-box">
      <input
        [ngStyle]="{'border': (submitted && passwordConfirmControl?.invalid) ? '1px rgba(152, 26, 48, 1) solid' : '1px white solid'}"
        autocomplete="off"
        formControlName="password_confirmation"
        placeholder="{{ 'FORM.PLACEHOLDER.CONFIRM_PASSWORD' | translate }}"
        [type]="textType"
      />
      <div 
        class="eye-icon"
        [ngClass]="{'show-password': textType === 'password', 'hide-password': textType === 'text'}"
        (click)="togglePasswordVisibility()">
      </div>
    </div>
    <div
      *ngIf="submitted && passwordConfirmControl?.hasError('required')"
      class="error-message"
    >
      {{ 'FORM.ERROR.REQUIRED' | translate }}
    </div>
    <div
      *ngIf="submitted && passwordConfirmControl?.hasError('password_mismatch')"
      class="error-message"
    >
      {{ 'FORM.VALID.PASSWORD_CONFIRM_VALID' | translate }}
    </div>
  </div>
</div>
